exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".A1-FM{text-align:center}._1RSe0{margin:0 auto}._3kZqv{font-family:Roboto,sans-serif;padding:25px 0}", ""]);

// exports
exports.locals = {
	"modalContent": "A1-FM",
	"modalFooter": "_1RSe0",
	"modalBody": "_3kZqv"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Telemedicina/ModalError/ModalError.css
// module id = 1025
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13